import { createSelector } from "@reduxjs/toolkit";

const selectWip = (state) => state.wip;

// New WIP Tracker selectors
export const selectWipTrackers = createSelector(
  [selectWip],
  (wip) => wip.trackers
);

export const selectWipTrackerDetails = createSelector(
  [selectWip],
  (wip) => wip.trackerDetails
);

export const selectWipComments = createSelector(
  [selectWip],
  (wip) => wip.comments
);

export const selectWipLoading = createSelector(
  [selectWip],
  (wip) => wip.loading
);

export const selectWipSaving = createSelector([selectWip], (wip) => wip.saving);

export const selectWipUploading = createSelector(
  [selectWip],
  (wip) => wip.uploading
);

export const selectWipError = createSelector([selectWip], (wip) => wip.error);

export const selectWipUploadSuccess = createSelector(
  [selectWip],
  (wip) => wip.uploadSuccess
);

export const selectWipSelectedTab = createSelector(
  [selectWip],
  (wip) => wip.selectedTab
);

// Legacy WIP selectors (for existing wip.component.js)
export const selectTransformedWipItems = createSelector(
  [selectWip],
  (wip) => wip.wipItems || []
);

export const selectWipStatusRollup = createSelector(
  [selectWip],
  (wip) => wip.statusRollup
);

// WIP Reports selectors (replaces batch update IDs)
export const selectWipReports = createSelector(
  [selectWip],
  (wip) => wip.wipReports || []
);

export const selectSelectedReportId = createSelector(
  [selectWip],
  (wip) => wip.selectedReportId
);

// Backward compatibility selectors
export const selectBatchUpdateIds = createSelector(
  [selectWipReports],
  (reports) => reports.map((report) => report._id) // Extract _id as batchUpdateId
);

export const selectSelectedBatchId = createSelector(
  [selectWip],
  (wip) => wip.selectedReportId // selectedReportId is the same as selectedBatchId
);

export const selectBatchItems = createSelector(
  [selectWip],
  (wip) => wip.batchItems
);

export const selectBatchPagination = createSelector(
  [selectWip],
  (wip) => wip.batchPagination
);

export const selectLoadingBatch = createSelector(
  [selectWip],
  (wip) => wip.loadingBatch
);

export const selectLockedState = createSelector(
  [selectWip],
  (wip) => wip.lockedState
);
